<template>
  <v-row>
    <v-col cols="12">
      <v-card class="bank-card" flat>
        <!-- HEADER BAND -->
        <div class="bank-header pl-base-bg">
          <div class="bank-header-icon">
            <v-icon color="#fff" size="22">mdi-bank-outline</v-icon>
          </div>
          <div>
            <div class="bank-title">Bank Account</div>
            <div class="bank-subtitle">{{ form.bankName || "Bank details for receiving payments" }}</div>
          </div>
        </div>

        <!-- FORM -->
        <v-form ref="form" v-model="valid" class="pa-6">
          <div class="bank-section-label">Account Details</div>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="form.bankName"
                label="Bank Name"
                outlined
                dense
                prepend-inner-icon="mdi-bank"
              />
            </v-col>

            <v-col cols="12" sm="4">
              <v-text-field
                v-model="form.accountNumber"
                label="Bank A/C No"
                outlined
                dense
                prepend-inner-icon="mdi-credit-card-outline"
              />
            </v-col>

            <v-col cols="12" sm="4">
              <v-text-field
                v-model="form.ifsc"
                label="RTGS / IFSC Code"
                outlined
                dense
                prepend-inner-icon="mdi-code-string"
                @input="form.ifsc = (form.ifsc || '').toUpperCase()"
              />
            </v-col>
          </v-row>

          <!-- ACTIONS -->
          <v-row v-if="isOwner" class="mt-4" justify="end" align="center" no-gutters>
            <v-btn color="secondary" @click="reset">Reset</v-btn>

            <v-btn
              class="bank-save-btn ml-3"
              :loading="loading"
              @click="submit"
            >
              Save Account
            </v-btn>
          </v-row>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "BankAccount",

  data() {
    return {
      valid: false,
      loading: false,
      form: {
        bankName: "",
        accountNumber: "",
        ifsc: "",
      },
    };
  },

  computed: {
    account() {
      return this.$store.state.bank?.account;
    },
  },

  created() {
    this.loadAccount();
  },

  methods: {
    ...mapActions("bank", ["getAccount", "saveAccount"]),

    async loadAccount() {
      try {
        await this.getAccount();

        if (this.account) {
          this.form = { ...this.account };
        }
      } catch (err) {
        console.error(err);
      }
    },

    async submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        await this.saveAccount(this.form);

        this.$toast?.success("Bank account saved successfully");
      } catch (err) {
        this.$toast?.error(
          err?.response?.data?.message || "Failed to save account",
        );
      } finally {
        this.loading = false;
      }
    },

    reset() {
      if (this.account) {
        this.form = { ...this.account };
      }
    },
  },
};
</script>

<style scoped>
.bank-card {
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(15, 30, 50, 0.1);
}

.bank-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
}

.bank-header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bank-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
}

.bank-subtitle {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 2px;
}

.bank-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  margin-bottom: 10px;
}

.bank-save-btn {
  background: var(--pl-base-bg-gradient) !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-transform: none !important;
  box-shadow: none !important;
}
</style>
